(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["ff-brands"] && !Shopify.designMode) return;
  try {
    const container = document.querySelector('.ff-brands');
  if (container) {
    const tabsNav = container.querySelector('.ff-brands__tabs');
    const filterNav = container.querySelector('.ff-brands__filter');
    const rows = container.querySelectorAll('.ff-brands__row[data-letter]');
    const filterBtns = filterNav.querySelectorAll('.ff-brands__filter-btn');

    const lettersSol = (container.dataset.lettersSol || '').split(',').filter(Boolean);
    const lettersCol = (container.dataset.lettersCol || '').split(',').filter(Boolean);

    let activeCategory = 'collection';

    function updateFilterButtons() {
      const availableLetters = activeCategory === 'sol' ? lettersSol : lettersCol;
      filterBtns.forEach((btn) => {
        const letter = btn.dataset.letter;
        if (!letter) {
          const btnText = btn.textContent.trim();
          const isAvailable = availableLetters.includes(btnText);
          if (isAvailable) {
            btn.disabled = false;
            btn.classList.remove('ff-brands__filter-btn--disabled');
            btn.dataset.letter = btnText;
          } else {
            btn.disabled = true;
            btn.classList.add('ff-brands__filter-btn--disabled');
          }
        } else {
          const isAvailable = availableLetters.includes(letter);
          if (isAvailable) {
            btn.disabled = false;
            btn.classList.remove('ff-brands__filter-btn--disabled');
          } else {
            btn.disabled = true;
            btn.classList.add('ff-brands__filter-btn--disabled');
            btn.classList.remove('ff-brands__filter-btn--active');
          }
        }
      });
    }

    function updateLinks() {
      const items = container.querySelectorAll('.ff-brands__item');
      const linkAttr = activeCategory === 'sol' ? 'linkSol' : 'linkCollection';
      items.forEach((item) => {
        const link = item.querySelector('.ff-media-link');
        if (link) {
          const url = item.dataset[linkAttr] || '';
          if (url) {
            link.href = url;
          }
        }
      });
    }

    function applyFilters() {
      const activeLetter = filterNav.querySelector('.ff-brands__filter-btn--active');
      const selectedLetter = activeLetter ? activeLetter.dataset.letter : null;
      const dataAttr = activeCategory === 'sol' ? 'sol' : 'collection';

      console.group('[ff-brands] applyFilters — category: ' + activeCategory + ' | letter: ' + (selectedLetter || 'none') + ' | dataAttr: ' + dataAttr);
      console.log('rows total:', rows.length);

      rows.forEach((row) => {
        const items = row.querySelectorAll('.ff-brands__item');
        let hasVisible = false;

        items.forEach((item) => {
          if (item.dataset[dataAttr] === 'true') {
            item.style.display = '';
            hasVisible = true;
          } else {
            item.style.display = 'none';
          }
        });

        const prevHidden = row.classList.contains('ff-brands__row--hidden');
        if (!hasVisible) {
          row.classList.add('ff-brands__row--hidden');
        } else if (selectedLetter) {
          row.classList.toggle('ff-brands__row--hidden', row.dataset.letter !== selectedLetter);
        } else {
          row.classList.remove('ff-brands__row--hidden');
        }
        const nowHidden = row.classList.contains('ff-brands__row--hidden');
        console.log('letter:', row.dataset.letter, '| items:', items.length, '| hasVisible:', hasVisible, '| hidden:', nowHidden, prevHidden !== nowHidden ? '← CHANGED' : '');
      });

      console.groupEnd();
    }

    tabsNav.addEventListener('click', (e) => {
      const tab = e.target.closest('.ff-brands__tab');
      if (!tab || tab.classList.contains('ff-brands__tab--active')) return;

      tabsNav.querySelectorAll('.ff-brands__tab').forEach((t) => {
        t.classList.remove('ff-brands__tab--active');
      });
      tab.classList.add('ff-brands__tab--active');

      activeCategory = tab.dataset.category;

      filterNav.querySelectorAll('.ff-brands__filter-btn--active').forEach((el) => {
        el.classList.remove('ff-brands__filter-btn--active');
      });

      updateFilterButtons();
      applyFilters();
      updateLinks();
    });

    filterNav.addEventListener('click', (e) => {
      const btn = e.target.closest('.ff-brands__filter-btn:not(:disabled)');
      if (!btn) return;

      const letter = btn.dataset.letter;
      const isActive = btn.classList.contains('ff-brands__filter-btn--active');

      filterNav.querySelectorAll('.ff-brands__filter-btn--active').forEach((el) => {
        el.classList.remove('ff-brands__filter-btn--active');
      });

      if (!isActive) {
        btn.classList.add('ff-brands__filter-btn--active');
      }

      applyFilters();
    });

    updateFilterButtons();
    applyFilters();
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["ff-countdown"] && !Shopify.designMode) return;
  try {
    const countdowns = document.querySelectorAll('.ff-countdown[data-countdown-date]');
  countdowns.forEach((el) => {
    const targetDate = new Date(el.dataset.countdownDate).getTime();
    if (isNaN(targetDate)) return;

    const daysEl = el.querySelector('[data-countdown-days]');
    const hoursEl = el.querySelector('[data-countdown-hours]');
    const minutesEl = el.querySelector('[data-countdown-minutes]');
    const secondsEl = el.querySelector('[data-countdown-seconds]');

    function updateText(container, value) {
      const textEl = container.querySelector('.ff-snippet-text');
      if (textEl) textEl.textContent = value;
    }

    function update() {
      const now = Date.now();
      const diff = Math.max(0, targetDate - now);

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);

      const pad = (n) => String(n).padStart(2, '0');

      if (daysEl) updateText(daysEl, pad(days));
      if (hoursEl) updateText(hoursEl, pad(hours));
      if (minutesEl) updateText(minutesEl, pad(minutes));
      if (secondsEl) updateText(secondsEl, pad(seconds));

      if (diff <= 0) clearInterval(timer);
    }

    update();
    const timer = setInterval(update, 1000);
  });
  } catch(e) { console.error(e); }
})();

})();
